<template>
  <v-container fluid>
    <v-row class="text-center">
      <v-col cols="12" md="4">
        <h1>Jefe de Comunidad</h1>
        <p>{{ jefeComunidadName || this.$store.state.Auth.user.name }}</p>
      </v-col>
      <v-col cols="12" md="4">
        <h1>Total de Cilindros</h1>
        <p>{{ formatCurrency(totalCilindros, true) }} Cilindros</p>
      </v-col>
      <v-col cols="12" md="4">
        <h1>Total a Pagar</h1>
        <p>{{ formatCurrency(totalPagar) }} Bs.</p>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="12" md="4">
        <h1>Comunidad</h1>
        <p>{{ comunidadName || comunidad }}</p>
      </v-col>
      <v-col cols="12" md="4" v-if="detail">
        <div v-for="cilindroPesosCantidad in detail.cilindros" :key="cilindroPesosCantidad.peso">
          <h1>Total de Cilindros {{ cilindroPesosCantidad.peso }}</h1>
          <p>{{ cilindroPesosCantidad.total }} Cilindros</p>
        </div>
      </v-col>
      <v-col cols="12" md="4">
        <h1>Fecha de Pedido</h1>
        <p>{{ dateOrder | moment("DD/MM/YYYY") }}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex"
import messageMixin from "@/mixins/common"

export default {
  name: "confirmacion-pedido-resumen",
  mixins: [messageMixin],
  props: {
    jefeComunidadName: {
      type: String,
      default: null,
    },
    comunidadName: {
      type: String,
      default: null,
    },
    totalCilindros: {
      type: Number,
      default: 0,
    },
    totalPagar: {
      type: Number,
      default: 0,
    },
    dateOrder: {
      type: Date,
    },
  },
  data() {
    return {
      cilindrosPesosCantidad: [],
    }
  },
  computed: {
    ...mapGetters("Auth", ["comunidad"]),
    ...mapState("Pedidos", ["detail"]),
  },
}
</script>
